import { ObjectHelpers } from '../helpers/object-helpers'

const enum RequestType {
    Get = 'GET'
}

export class RequestService {
    constructor() { }

    public async get(url: string, success?: Function, fail?: Function) {
        return this.request(url, RequestType.Get, success, fail);
    }

    public async getJSON(url: string, success?: Function, fail?: Function) {
        return this.requestJSON(url, RequestType.Get, success, fail);
    }

    private requestJSON(url: string, rt: RequestType, success?: Function, fail?: Function) {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: rt,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response: Response) => {
                if (response.status === 200 || response.status === 204) {
                    this.successStatusResponse(response, resolve, success);
                } else {
                    this.unsuccessStatusResponse(response, reject, fail);
                }
            }).catch((err: any) => {
                if (fail) {
                    fail(err);
                }

                reject(err);
            });
        });
    }

    private request(url: string, rt: RequestType, success?: Function, fail?: Function) {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: rt
            }).then((response: Response) => {
                if (response.status === 200 || response.status === 204) {
                    this.successStatusResponse(response, resolve, success);
                } else {
                    this.unsuccessStatusResponse(response, reject, fail);
                }
            }).catch((err: any) => {
                if (fail) {
                    fail(err);
                }

                reject(err);
            });
        });
    }

    private successStatusResponse(response: Response, resolve: Function, successCallback?: Function) {
        const callback = (data: any) => {
            if (successCallback) {
                successCallback(data);
            }
            resolve(data);
        };

        if (response.status === 204) {
            callback(null);
            return;
        }

        const contentType = response.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
            response.json().then(data => {
                callback(ObjectHelpers.toCamel(data));
            });
        } else {
            response.text().then(text => {
                callback(text);
            });
        }
    }

    private unsuccessStatusResponse(response: Response, reject: Function, failCallback?: Function) {
        const callback = (err: any) => {
            if (failCallback) {
                failCallback(err);
            }
            reject(err);
        };

        response.text().then((txt: any) => {
            try {
                const json = JSON.parse(txt);
                callback(json);
            } catch {
                callback(txt)
            }
        })
            .catch(() => callback(response));
    }
}